import { SelfLearningContentTypeFromJSON, SelfLearningContentTypeToJSON, } from './SelfLearningContentType';
/**
 * Check if a given object implements the SelfLearningUnitGroupsSwapRequest interface.
 */
export function instanceOfSelfLearningUnitGroupsSwapRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "id2" in value;
    isInstance = isInstance && "id1" in value;
    isInstance = isInstance && "contentType" in value;
    return isInstance;
}
export function SelfLearningUnitGroupsSwapRequestFromJSON(json) {
    return SelfLearningUnitGroupsSwapRequestFromJSONTyped(json, false);
}
export function SelfLearningUnitGroupsSwapRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id2': json['id2'],
        'id1': json['id1'],
        'contentType': SelfLearningContentTypeFromJSON(json['contentType']),
    };
}
export function SelfLearningUnitGroupsSwapRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id2': value.id2,
        'id1': value.id1,
        'contentType': SelfLearningContentTypeToJSON(value.contentType),
    };
}
